import gql from "graphql-tag";

// noinspection GraphQLUnresolvedReference
export const insightsStartDateQuery = gql`
            query {
                records:periods(isInsightsStart: true) {
                 firstWeekOfPeriod {
                  endDate 
                  weekId
                  } 
                }
            }`;